<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  components: {}
};
</script>


<style lang="stylus">
html, body, .user-content {
  height: 100%;
}

*, body {
  padding: 0px;
  margin: 0px;
  font-family: PingFangSC-Regular;
}

a {
  text-decoration-line: none;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(40, 47, 60, 1);
}

a.active {
  color: #00AEEF;
}

.muhua-title {
  font-size: 30px;
  font-weight: 400;
  color: rgba(63, 80, 124, 1);
  line-height: 23px;
  display: block;
  padding: 48px;
  text-align: center;
}

.muhua-wrap {
  width: 80%;
  max-width: 980px;
  margin: 0 auto;
  text-align: center;
}

.muhua-little-title {
  font-size: 10px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(116, 133, 152, 1);
  line-height: 30px;
}

.common-width {
  max-width: 1000px;
  margin: 0 auto;
  width: 50%;
}

.el-menu.el-menu--horizontal {
  border-bottom: 0px !important;
}

// .el-menu--horizontal > .el-menu-item a, .el-menu--horizontal > .el-menu-item a:hover {
// color: #00AEEF !important;
// }
.cursor-point {
  cursor: pointer;
}

.button:hover {
  background: #008BBF;
  color: #fff;
}

.button {
  background: #00aeef;
  border-radius: 2px;
  border: 1px solid #00aeef;
  color: #fff;
  display: inline-block;
  width: 150px;
  height: 40px;
  text-align: center;
  font-size: bold;
  line-height: 40px;
  margin-bottom: 39px;
}

.white-button:hover {
  background: rgba(255, 255, 255, 1);
  color: rgba(0, 174, 239, 1);
}

.white-button {
  color: rgba(0, 174, 239, 1);
  background: #fff;
}

.disable-button {
  background: rgba(255, 255, 255, 1);
  color: rgba(197, 202, 215, 1);c
  border: 1px solid #c5cad7;
}

.disable-button:hover {
  background: rgba(255, 255, 255, 1);
  color: rgba(0, 174, 239, 1);
}

.home-header {
  height: 60px;
  background: #fff;
  width: 80%;
  margin: 0 auto;
  position: relative;
  max-width: 1200px;
}

.home-header.admin-header{
  width: 100%;
  max-width: 100%;
}

.admin-home .el-menu-item {
  width: 180px !important;
}

.bonus-cursor
  cursor: pointer;


.blue-background{
  background: #f8fcff;
}

.basic-wrap{
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
}

.button {
  width: 120px;
  height: 40px;
  background: rgba(0, 174, 239, 1);
  border-radius: 4px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  line-height: 16px;
  font-family: MicrosoftYaHei;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  margin: 0 auto;
}

/** 控制菜单 **/ 
.el-menu--popup.el-menu--popup, .el-menu--horizontal .el-submenu .el-menu-item {
  width: 140px !important;
  min-width: 140px;
}

.height-220 {
  height: 222px;
}

.el-menu--horizontal > .el-submenu .el-submenu__title {
  line-height: 64px !important; 
}

.el-menu {
  border-right: 0px !important; 
}
</style>

